import React, { Component } from "react";
import SwiperSlider, { SwiperSlide } from "./swiper";
import { EffectFade } from "swiper";

class TestimonialSlider extends Component {
  render() {
    const params = {
      slidesPerView: 1,
      loop: true,
      autoplay: false,
      effect: "fade",
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true
      },
      modules: [EffectFade]
    };
    let data = [
      {
        testimonialImage: "banner.jpg",
        testimonialName: "James Anderson",
        testimonialDesignation: "Project Manager",
        testimonialText:
          "Prixin delivered our commercial complex project ahead of schedule with outstanding quality. Their attention to safety and detail is unmatched in the industry."
      },
      {
        testimonialImage: "3.jpg",
        testimonialName: "Sarah Jenkins",
        testimonialDesignation: "Civil Engineer",
        testimonialText:
          "I have worked with many contractors, but Prixin stands out for their technical expertise and modern equipment fleet. Highly recommended for heavy infrastructure work."
      },
      {
        testimonialImage: "2.jpg",
        testimonialName: "Michael Ross",
        testimonialDesignation: "Operations Director",
        testimonialText:
          "Their equipment rental service is reliable and efficient. We sourced all our heavy machinery from Prixin for the highway expansion project and faced zero downtime."
      }
    ];

    let DataList = data.map((val, i) => {
      return (
        <SwiperSlide key={i}>
          <div className="testimonial-slider__single-slide">
            <div className="author">
              {/* <div className="author__image">
                <img
                  src={`assets/img/others/${val.testimonialImage}`}
                  alt=""
                />
              </div> */}
              <div className="author__details">
                <h4 className="name">{val.testimonialName}</h4>
                <div className="designation">{val.testimonialDesignation}</div>
              </div>
            </div>
            <div className="content">{val.testimonialText}</div>
          </div>
        </SwiperSlide>
      );
    });

    return (
      <div>
        {/*====================  testimonial slider area ====================*/}
        <div
          className="testimonial-slider-area testimonial-slider-area-bg section-space--inner--120"
          data-aos="fade-up"
          style={{
            backgroundImage: `url(assets/img/others/banner.jpg)`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat"
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-10 offset-lg-1">
                <div className="testimonial-slider">
                  <div className="testimonial-slider__container-area">
                    <SwiperSlider options={params}>{DataList}</SwiperSlider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*====================  End of testimonial slider area  ====================*/}
      </div>
    );
  }
}

export default TestimonialSlider;
